import React from 'react'
import PropTypes from 'prop-types'
import Row from '../row'
import Col from '../col'
import LazyImage from '../lazyImage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from '@fortawesome/free-solid-svg-icons'

const SearchListItem = ({ hit, components, marketplaceUrl, url }) => {
  const hasImage = !!hit.image?.versionAndPublicId
  const itemUrl = hit.auctionUuid === 'marketplace' ? marketplaceUrl : url
  return (
    <a href={itemUrl.replace('%AUCTION_ID%', hit.auctionUuid).replace('%ITEM_ID%', hit.objectID)} className='searchListItem'>
      <Row className='searchListItem__content'>
        <Col xs={4} sm={3} md={2}>
          {hasImage
            ? (
              <LazyImage
                aspectHeight={240}
                aspectWidth={320}
                className='searchListItem__image'
                label={hit.title}
                key={`searchListItem__image--${hit.image.versionAndPublicId}`}
                src={hit.image.versionAndPublicId}
              />
              )
            : (
              <div className='ratio--flex-wrapper'>
                <div className='lot__media--missing'>
                  <FontAwesomeIcon icon={faImage} />
                </div>
              </div>
              )}
        </Col>
        <Col xs={8} sm={9} md={10}>
          <h5 className='searchListItem__title'>
            <components.Highlight hit={hit} attribute='title' />
          </h5>
          <div className='searchListItem__summary'>
            <small className='text-muted'>
              <components.Highlight hit={hit} attribute='summary' />
            </small>
          </div>
        </Col>
      </Row>
    </a>
  )
}

SearchListItem.propTypes = {
  components: PropTypes.shape({
    Highlight: PropTypes.func
  }),
  hit: PropTypes.shape({
    auctionUuid: PropTypes.string,
    image: PropTypes.shape({
      versionAndPublicId: PropTypes.string.isRequired
    }),
    objectID: PropTypes.string,
    summary: PropTypes.string,
    title: PropTypes.string
  }),
  marketplaceUrl: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
}

export default SearchListItem
